const StartOfImageMarker = {
  name: () => "SOI",
};

export default StartOfImageMarker;
